module.exports = __webpack_public_path__ + "fonts/Calibre-MediumItalic.4afe8032.woff";